import getApiClient, { getAnnonymousApiClient } from "./../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../notifications/ducks/actions";
import invitations from "../../../shared/invitations";

export const CLEAR_LOGIN_REDIRECT = "CLEAR_LOGIN_REDIRECT";

export function login(user, origin) {
  //user.invitations = invitations.getInvitations();
  return (dispatch) => {
    dispatch({
      type: "LOGIN",
      payload: getAnnonymousApiClient().post(`/account/login`, user),
      meta: { user, origin }
    })
      .then((response) => {
        //TODO: Work out why this happens 2 or more times              
        invitations.removeInvitations();

        // if (response.value.data.needToTakePayment) {
        //   history.push('/payment');
        //   return;
        // }
        // if (!response.value.data.hasInvitationErrors) {
        //   if (origin) {
        //     history.push(origin);
        //   } else {
        //     history.push('/films');
        //   }
        // }

      })
      .catch((response) => {
        dispatch(showError(`Error logging in`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function clearErrors() {
  return (dispatch) => {
    dispatch({
      type: "LOGIN_CLEAR_ERRORS",
    });
  };
}

export function resendEmailConfirmation(emailAddress) {
  return (dispatch) => {
    dispatch({
      type: "RESEND_EMAIL_CONFIRMATION",
      payload: getAnnonymousApiClient().post(`/account/ResendEmailConfirmation`, { emailAddress })
    }).then((response) => {
      dispatch(showInfo(`Successfully resent email confirmation`));
    })
      .catch((response) => {
        dispatch(showError(`Error sending email confirmation`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function clearRedirect(dispatch) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_LOGIN_REDIRECT,
    });
  };
}
